export class RedirectLoginStrategy {
  _browser

  constructor(browser) {
    this._browser = browser;
  }

  login() {
    const currentUrl = this._browser.getCurrentUrl();
    const redirectUrl = process.env.LOGIN_URL + encodeURIComponent(currentUrl);
    this._browser.redirectToUrl(redirectUrl);
  }
}